<template>
    <div>
        <rateios-tabela
            :rateios="rateios"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
        >
        </rateios-tabela>
    </div>
</template>

<script>
import RateiosTabela from './RateiosTabela'

export default {
    components: {
        RateiosTabela
    },

    props: {
        rateios: {
            type: Array
        },

        valorASerRateado: {
            type: Number
        },

        valorDisponivel: {
            type: Number
        }
    }
}
</script>
